import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=28812147"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports